import { doAppGraphqlRequest } from 'ducks/requests'

import { FETCH_CUSTOM_PROFILE } from './types'

const fetchCustomProfileQuery = `
  query FetchCustomProfile($contactId: ID!, $hard: Boolean) {
    customProfile(contactId: $contactId, hardRefresh: $hard)
  }
`
export function doFetchCustomProfile(contactId, hard = false) {
  return doAppGraphqlRequest(FETCH_CUSTOM_PROFILE, fetchCustomProfileQuery, {
    contactId,
    hard,
  })
}
